/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetCharactersCharacterIdCalendarEventIdNotFound
 */
export interface GetCharactersCharacterIdCalendarEventIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetCharactersCharacterIdCalendarEventIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdCalendarEventIdNotFound interface.
 */
export function instanceOfGetCharactersCharacterIdCalendarEventIdNotFound(value: object): value is GetCharactersCharacterIdCalendarEventIdNotFound {
    return true;
}

export function GetCharactersCharacterIdCalendarEventIdNotFoundFromJSON(json: any): GetCharactersCharacterIdCalendarEventIdNotFound {
    return GetCharactersCharacterIdCalendarEventIdNotFoundFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdCalendarEventIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdCalendarEventIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCharactersCharacterIdCalendarEventIdNotFoundToJSON(json: any): GetCharactersCharacterIdCalendarEventIdNotFound {
    return GetCharactersCharacterIdCalendarEventIdNotFoundToJSONTyped(json, false);
}

export function GetCharactersCharacterIdCalendarEventIdNotFoundToJSONTyped(value?: GetCharactersCharacterIdCalendarEventIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

